
import { defineComponent } from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import useSignOut from "@/use/signout";
import Modal from "@/components/shared/Modal.vue";

export default defineComponent({
  setup() {
    const { signOut } = useSignOut();
    return { signOut };
  },
  props: {},
  components: { Modal },
  data: () => ({
    time: 60000
  }),
  computed: {
    ...mapState(["idleVue"]),
    ...mapGetters("oidcStore", ["oidcUser"]),
    seconds(): number {
      return this.time / 1000;
    }
  },
  methods: {
    ...mapActions("oidcStore", ["removeOidcUser", "signOutOidcSilent"])
  },
  mounted() {
    const timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
        this.signOut();
      }
    }, 1000);
  }
});
